import API from 'constants/API';

import {AxiosResponse} from 'axios';
import {GetPageEditorsDTO} from 'typescript/dto/pageEditorsDto';
import ApiData from 'typescript/interfaces/ApiData';
import PageEditor from 'typescript/models/PageEditor';
import User from 'typescript/models/User';
import {queryBuilder} from 'utils/helpers/queryBuilder';
import httpClient from 'utils/httpClient/httpClient';

export const getPageEditorsData = (search: GetPageEditorsDTO): Promise<AxiosResponse<ApiData<User[]>>> => {
  const {page, perPage, name, direction, column} = search;

  const baseQuery = queryBuilder({
    baseQuery: `${API.PAGE_EDITORS_SERVICE.BASE}`,
    queryObject: {
      page,
      per_page: perPage,
      'filter[query_array]': name,
      'filter[sort_column]': column,
      'filter_sort[sort_direction]': direction,
    },
  });

  return httpClient.get(baseQuery);
};

export const removePageEditor = (id: string): Promise<AxiosResponse> => {
  return httpClient.delete(`${API.PAGE_EDITORS_SERVICE.BASE}/${id}`);
};

export const deleteSingleEditor = (id: string): Promise<AxiosResponse<PageEditor>> => {
  return httpClient.delete(`${API.PAGE_EDITORS_SERVICE.BASE}/${id}`);
};
